<template>
    <div>
        <modal class="auto-setting-batch" :display="modalStatus.autoSettingBatch" @modalStatus="closeModal" >
            <transition name="fade">
                <div v-if="showTips" class="success">
                    <img src="@/assets/img/icon/tick_blue.svg" alt="" srcset="">
                    成功更新
                </div>
            </transition>
            <h1>通知設定</h1>
            <div class="auto-setting-batch-wrap">
                <div class="description">
                    自動收租：開啟自動收租後，將於下期帳單的應繳日自動發送帳單給租客<br>
                    收租提醒：在每月應繳日前五天時，將自動發推播提醒您設定本月租金
                </div>
                <div class="content">
                    <div class="table-title">
                        <div class="name">房源名稱</div>
                        <div class="rent">租金</div>
                        <div class="address">房源地址</div>
                        <div class="tenant">租客</div>
                        <div class="next-bill">下期帳單</div>
                        <div class="auto-create">自動收租</div>
                        <div class="auto-send">收租提醒</div>
                    </div>
                    <div class="table-body" >
                        <ul :key="'height'+componentKey" v-bind:style="{'height': modalHeight}">
                            <li v-for="(item, index) in leaseDoneList" :key="index">
                                <div class="name">{{item.name}}</div>
                                <div class="rent">{{toCurrency(item.rentPrice)}}</div>
                                <div class="address">{{item.address}}</div>
                                <div class="tenant">{{item.tenantName}}</div>
                                <div class="next-bill">{{item.nextBillBeginTime}}-{{item.nextBillEndTime}}</div>
                                <div @click="setAutoSendBill()" class="auto-create">
                                    <rent-switch v-model="editList[index].autoCreate" :dValue="item.isAutoCreated" ></rent-switch>
                                </div>
                                <div @click="setAutoSendBill()" class="auto-send">
                                    <rent-switch v-model="editList[index].autoSend" :dValue="item.isAutoSend" ></rent-switch>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- <div class="btn-group">
                <button class="default-button confirm" @click="setAutoSendBill">儲存設定</button>
                <button class="border-button reject" @click="closeModal">取消</button>
            </div> -->
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import RentSwitch from '@/components/widge/RentSwitch.vue';
import { mapGetters } from 'vuex'

import { 
    apiSetAutoSendBill
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            modalHeight: (window.innerHeight-300) + 'px',
            componentKey: 0,
            value: false,
            editList: [],
            showTips: false,
            isChange: false
        }
    },
    props: {
        cid: Number,
        isAutoCreate: Boolean
    },
    mounted (){
        window.addEventListener('resize', this.resizeModal)
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeModal)
    },
    watch: {
        leaseDoneList: {
            handler: function () {
                this.setEditList()
            },
            immediate: true
        },
        'modalStatus.autoSettingBatch': function (val) {
            if(val){
                // console.log('批次通知設定')
                this.$analytics.logEvent('批次通知設定', { screen_name: '批次通知設定'})
            }
        }
        // editList: {
        //     handler: function (newValue, oldValue) {
        //         console.log(newValue)
        //         console.log(oldValue)
        //         apiSetAutoSendBill(newValue)
        //         .then(res => {
        //             if( res.data.status == "SUCCESS" ){
        //                 this.showTip()
        //                 // this.$emit('saveAutoStatus');
        //                 // this.$store.dispatch('getLeaseDoneMgtList')
        //             }
        //         })
        //         .catch(err => {
        //             console.log(err)
        //         })
        //     },
        //     immediate: true,
        //     deep: true
        // }
    },
    methods: {
        resizeModal: function (){
            let _self = this
            console.log(window.innerHeight)
            if( window.innerHeight > 610){
                _self.modalHeight = (window.innerHeight-300) + 'px'
                _self.componentKey += 1
            }
        },
        showTip: function () {
            var _self = this;
            _self.showTips = true
            setTimeout(function() {
                _self.showTips = false;
            }, 1500); 
        },
        setAutoSendBill: function () {
            this.$analytics.logEvent('送出通知設定', { screen_name: '送出通知設定'})
            let data = this.editList
            apiSetAutoSendBill(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // this.showTip()
                    this.isChange = true
                    // this.$emit('saveAutoStatus');
                    // this.closeModal()
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        setEditList: function () {
            this.editList = []
            let list = this.leaseDoneList
            for (let index = 0; index < list.length; index++) {
                const element = list[index];
                this.editList.push(
                    {
                        "contractCid": element.contractCid,
                        "autoCreate" : element.isAutoCreated,
                        "autoSend" : element.isAutoSend
                    }
                )
                
            }
        },
        closeModal: function () {
            if(this.isChange){
                this.$emit('saveAutoStatus');
                this.isChange = false
            }
            this.$store.dispatch('getLeaseDoneMgtList')
            this.$store.dispatch('setModalStatus', {state: false, type: 'autoSettingBatch'})
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
    },
    computed: {
        isOpen: function () {
            if(this.value){
                return '開啟'
            }else{
                return '關閉'
            }
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
            leaseDoneList: 'GET_LEASE_DONE_MGT_LIST'
        })
    },
    components: {
        Modal,
        RentSwitch
    }
}
</script>
<style lang="scss"  >
    #modal.auto-setting-batch{
        .error{
            right: 0px;
            top: 7px;
        }
        .modal-content{
            width: 1286px;
            padding: 0 !important;
            .detail{
                .success{
                    position: absolute;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 122px;
                    height: 40px;
                    border-radius: 4px;
                    background-color: #fff;
                    top: -60px;
                    img{
                        margin-right: 2px;
                    }
                }
                >h1{
                    margin-top: 32px;
                    margin-bottom: 24px;
                }
                .auto-setting-batch-wrap{
                    padding: 0 32px 0 32px;
                    .description{
                        font-weight: 300;
                        line-height: 1.57;
                        margin-bottom: 20px;
                        text-align: center;
                    }
                    .content{
                        .table-title{
                            padding: 20px 20px;
                            border-top: 1px solid #F1F5F4;
                            border-bottom: 1px solid #F1F5F4;
                            display: flex;
                            align-items: center;
                            color: #a8a5a4;
                        }
                        .table-body{
                            ul{
                                &::-webkit-scrollbar {
                                    display: none;
                                }
                                height: 392px;
                                overflow-x: hidden;
                                li{
                                    display: flex;
                                    align-items: center;
                                    padding: 20px 20px;
                                    border-bottom: 1px solid #F1F5F4;
                                }
                            }
                        }
                        .table-title .name,
                        .table-body ul li .name{
                            width: 200px;
                            margin-right: 40px;
                        }
                        .table-title .rent,
                        .table-body ul li .rent{
                            width: 51px;
                            margin-right: 71px;
                        }
                        .table-body ul li .rent{
                            text-align: right;
                        }
                        .table-title .address,
                        .table-body ul li .address{
                            width: 300px;
                            margin-right: 60px;
                        }
                        .table-title .tenant,
                        .table-body ul li .tenant{
                            width: 52px;
                            margin-right: 50px;
                        }
                        .table-title .next-bill,
                        .table-body ul li .next-bill{
                            width: 152px;
                            margin-right: 60px;
                        }
                        .table-title .auto-create,
                        .table-body ul li .auto-create{
                            width: 61px;
                            margin-right: 34px;
                        }
                        .table-title .auto-send,
                        .table-body ul li .auto-send{
                            width: 61px;
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 184px;
                    height: 44px;
                }
                button.confirm{
                    margin-right: 16px;
                }
            }
        }
    }
    @media screen and (max-width: 1280px) {
        #modal.auto-setting-batch{
            .modal-content{
                width: 1194px;
                .detail{
                    .auto-setting-batch-wrap{
                        .content{
                            .table-title .name,
                            .table-body ul li .name{
                                width: 160px;
                                margin-right: 40px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/AutoSettingBatch.vue